import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
} from "@mui/material";
//import * as React from "react";
import { useState } from "react";
import { useSelector } from "react-redux";
import { ButtonItem } from "../../../../entities/UIEntities/ButtonItem";
import { commonActions } from "../../../../redux/reducers/CommonReducer";
import { userActions } from "../../../../redux/reducers/UserReducer";
import * as userScopesActionsService from "../../../../services/ActionsService/UserScopesActionsService";
import store from "../../../../redux/Store";
import Strings from "../../../../resources/Strings";
import EllipseButton from "../../Buttons/EllipseButton/EllipseButton";
import classes from "./MessageModal.module.css";
import wizardFormClasses from "../../Forms/Wizard Forms/WizardForm.module.css";
import { updateGmtUserScopes } from "../../../../utils/MenuUtils";
import {
  showErrorMessage,
  showUpdateSuccessMessage,
} from "../../../../utils/MessagesUtils";
import UserTypesButtons from "../../Buttons/CustomToggleButton/UserTypesButtons/UserTypesButtons";
import { ROLES_NAMES } from "../../../../enums/Enums";

const DisactiveMessageModal = (props) => {
  const isNonProject = props?.userData?.isNonProject;
  const scopes = useSelector((state) => state.user?.scopes); // added
  //const selectedScope = useSelector((state) => state.user?.selectedScope);

  const userRoles = useSelector((state) => state.user.initialState.roles); 
  const buttonsList = userRoles.map((role) => new ButtonItem(role.id, role.name))?.filter(button => (button.name !== ROLES_NAMES.CUSTOMER && button.name !== ROLES_NAMES.INACTIVE)); 
  
  const messageModal = useSelector((state) => state.common.messageModal);
  
  // according to the isActivateUserMenu mode - disable / active show the relevant scopes
  // if mode is active - show scopes to disable, if mode is disabled - show scopes to activate to
  // when on active list, the available list to choose will be filtered by the selectedScope parentId
  const allowedUserScopes = !props?.userData?.isActivateUserMenuItem ? 
  scopes.filter(scope => props?.userData?.userScopes.some(us => us.scopeId === scope.id && us?.role?.name !== 'Inactive')) : 
  scopes.filter(scope => props?.userData?.userScopes.some(us => us.scopeId === scope.id && us?.role?.name === 'Inactive')) //scopes.filter(scope => scope.parentId === selectedScope.id);

  // the user's scope selection on the modal
  // on project auto-select the scope
  const [selectedScopes, setSelectedScopes] = useState(isNonProject ? [] : [props?.userData?.selectedScope?.id]); 
  const [selectedPermission, setSelectedPermission] = useState(buttonsList[0].id); // sets Collaborator as default selection

  const handleClose = () => {
    if (messageModal.cancelAction) {
      messageModal.cancelAction();
    }
    store.dispatch(commonActions.closeMessageModal());
  };

  // when user is inactive - handles the pop up of role permission selection
  const handlePermissionChange = (event, role) => {
    setSelectedPermission(role);
  };

  const handleChange = (event) => {
    let isActiveMode = props?.userData?.isActivateUserMenuItem;

    let selectedScopesCopy = [...selectedScopes];
    if (event.target.checked) {
      if (selectedScopesCopy?.length > 0 && isActiveMode) {
        // single selection - on active mode
        selectedScopesCopy[0] = event.target.name;
      }
      else {
        // multi selection - on disactive mode
        selectedScopesCopy.push(event.target.name);
      }
    } else {
      const index = selectedScopesCopy.indexOf(event.target.name);
      if (index >= 0) {
        selectedScopesCopy.splice(index, 1);
      }
    }
    
    setSelectedScopes(selectedScopesCopy);
  };

  const getRoleName = (scopeId) => {
    // if role by scopeId founded, use the role name, otherwise set empty string
    const roleName = props?.userData?.userScopes.find(
      (scope) => scope.scopeId === scopeId
    )?.role?.name !== undefined ? 
    ` - ${props?.userData?.userScopes.find(
      (scope) => scope.scopeId === scopeId
    )?.role?.name}`
     : "" ;

    return roleName;
  };

  const confirmAction = () => {
    let userScopesList = props?.userData?.userScopes?.length > 0 ? props?.userData?.userScopes : [];
    if (!props?.userData?.isActivateUserMenuItem) {
      if (userScopesList?.length > 0) {
        // set inactive role to the selectedScopes only
        let filteredUserScopesList = userScopesList?.filter(us => selectedScopes.some(sl => us.scopeId === sl));
        userScopesActionsService
          .inactiveUserScopeRoleList(filteredUserScopesList) // userScopesList
          .then((response) => {
            store.dispatch(commonActions.closeMessageModal());
            if (response.data.isSuccess) {
              if (response?.data?.entity) {
                updateGmtUserScopes(response.data.entity);
              }
              //store.dispatch(userActions.updateGmtUserScope(response.data));
              showUpdateSuccessMessage();
            } else {
              showErrorMessage(response.data?.error);
            }
          });
      }
    }
    else {
      // when non-project, set the userScopeToUpdate as the userScope that was selected
      // on project - take the first (no list will be shown to select)
      // take a copy from the founded userScope in order to be able to change its values
      let userScopeToUpdate = props?.userData?.isNonProject ? 
      {...userScopesList?.find(us => selectedScopes.some(sl => us.scopeId === sl))} : 
      {...userScopesList[0]}; // on project
      userScopeToUpdate.roleId = selectedPermission;
      
      userScopesActionsService.updateUserScopeRole(userScopeToUpdate).then((response) => {
        store.dispatch(commonActions.closeMessageModal());
        if (response.data.isSuccess) {
          store.dispatch(userActions.updateGmtUserScope(response.data));
          showUpdateSuccessMessage();
          //store.dispatch(userActions.setShowUserInfoWindow(false));
        } else {
          showErrorMessage(response.data?.error);
        }
      });
    }
  };

  return (
    <>
      {isNonProject === true ? (
        <div style={{ width: "100%" }}>
          <FormControl
            required
            component="fieldset"
            className={classes.formControl}
          >
            <FormGroup className={classes.formGroup}>
              {props?.userData?.isActivateUserMenuItem ? (
                <>
                <div className={classes.centerList}>
                  {allowedUserScopes?.map((scope) => {
                    return (
                      <FormControlLabel
                        key={scope.id}
                        control={
                          <Checkbox
                            checked={selectedScopes.includes(scope?.id.toString())}
                            onChange={handleChange}
                            name={scope?.id}
                            classes={{ checked: classes.checked }}
                          />
                        }
                        label={
                          <div className={classes.checkboxLabel}>{`${
                            scope?.name
                          } ${getRoleName(scope?.id)}`}</div>
                        }
                      />
                    );
                  })}
                  </div>
                  <div
                    className={wizardFormClasses.userTypePermissionContainer}
                    /*style={{ marginBottom: '25px', marginTop: '25px'}}*/
                  >
                    <UserTypesButtons
                      buttonsList={buttonsList}
                      selectedValue={selectedPermission}
                      handleChange={handlePermissionChange}
                      isEditMode={props.isEditMode}
                      fromPermission={true}
                    />
                  </div>
                </>
                
              ) : (
                <>
                  <div className={classes.centerList}>
                    {allowedUserScopes?.map((scope) => {
                      return (
                        <FormControlLabel
                          key={scope.id}
                          control={
                            <Checkbox
                              checked={selectedScopes.includes(scope?.id.toString())}
                              onChange={handleChange}
                              name={scope?.id}
                              classes={{ checked: classes.checked }}
                            />
                          }
                          label={
                            <div className={classes.checkboxLabel}>{`${
                              scope?.name
                            } ${getRoleName(scope?.id)}`}</div>
                          }
                        />
                      );
                    })}
                    </div>
                </>
                )}
                
            </FormGroup>
          </FormControl>
          <div className={classes.modalButtons}>
            <EllipseButton onClick={confirmAction} disabled={selectedScopes?.length < 1 /*!props?.userData.isActivateUserMenuItem ? selectedScopes?.length < 1 : selectedScopes?.length !== 1*/}>
              {Strings.YES_PLEASE}
            </EllipseButton>
            <EllipseButton isCancelButton={true} onClick={handleClose}>
              {Strings.CANCEL}
            </EllipseButton>
          </div>
        </div>
      ) : (
        // Project Modal
        <div>
          <FormControl
            required
            component="fieldset"
            className={classes.formControl}
          >
            <FormGroup className={classes.formGroup}>
              {props?.userData?.isActivateUserMenuItem && (
                <div
                  className={wizardFormClasses.userTypePermissionContainer}
                  /*style={{ marginBottom: '25px', marginTop: '25px'}}*/
                >
                  <UserTypesButtons
                    buttonsList={buttonsList}
                    selectedValue={selectedPermission}
                    handleChange={handlePermissionChange}
                    isEditMode={props.isEditMode}
                    fromPermission={true}
                  />
                </div>
              )}
            </FormGroup>
          </FormControl>
          <div className={classes.modalButtons}>
            <EllipseButton onClick={confirmAction}>
              {Strings.IM_SURE}
            </EllipseButton>
            <EllipseButton isCancelButton={true} onClick={handleClose}>
              {Strings.CANCEL}
            </EllipseButton>
          </div>
        </div>
      )}
    </>
  );
};

export default DisactiveMessageModal;
